import styled from 'styled-components';

import { StyledSelect } from 'components/Input/styles';

import { colors } from 'theme/colors';

export const Dropdown = styled(StyledSelect)`
  appearance: none;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.primary.dark};
  height: 40px;
  font-size: 14px;

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-select {
    background-color: initial;
    margin-left: 8px;
  }

  .MuiMenuItem {
    font-size: 14px;
  }

  &.Mui-disabled {
    color: black;
    background-color: ${colors.legacy.secondary.main};
  }

  .MuiSelect-icon.Mui-disabled {
    color: black;
  }
`;
